(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Coupon', Coupon);

    Coupon.$inject = ['$resource', 'DateUtils', 'ENV'];

    function Coupon($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/coupon/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
